// extracted by mini-css-extract-plugin
export default {"wrapper":"load-previous-shift-section_wrapper__+vqG9"};